import React from "react";

import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableBody from "@material-ui/core/TableBody";

import { useSelector, useDispatch } from "react-redux";

import { Box, Typography } from "@material-ui/core";
import Pagination from "@material-ui/lab/Pagination";
import { animateScroll as scroll } from "react-scroll";
import PointsBankTableHeading from "./PointsBankTableHeading";
import PointsBankTableItem from "./PointsBankTableItem";
import NewsRequests from "services/news";

const PointsBankTable = ({ searchStr }) => {
  const { pointsBank, pointsBankCurrentPage, pointsBankTotalPages } = useSelector(
    ({ news }) => news
  );
  const dispatch = useDispatch();

  const handleChangePagination = (_, value) => {
    if (searchStr) {
      dispatch(NewsRequests.fetchAllPointsBank(value, searchStr));
    } else {
      dispatch(NewsRequests.fetchAllPointsBank(value, ""));
    }
    scroll.scrollToTop();
  };

  return (
    <div className="Cmt-table-responsive">
      {pointsBank && pointsBank.length === 0 ? (
        <Box
          display={"flex"}
          justifyContent={"center"}
          paddingTop={"30px"}
          paddingBottom={"20px"}
        >
          <Typography variant="h3">موردی برای نمایش وجود ندارد</Typography>
        </Box>
      ) : (
        <Table>
          <TableHead>
            <PointsBankTableHeading />
          </TableHead>
          <TableBody>
            {pointsBank.map((item) => (
              <PointsBankTableItem data={item} key={item._id} />
            ))}
          </TableBody>
        </Table>
      )}
      {pointsBank.length !== 0 ? (
        <Box display={"flex"} justifyContent={"center"} marginTop={"20px"}>
          <Pagination
            count={pointsBankTotalPages}
            color="primary"
            page={pointsBankCurrentPage}
            onChange={handleChangePagination}
          />
        </Box>
      ) : null}
    </div>
  );
};

export default PointsBankTable;